document.addEventListener("DOMContentLoaded", function () {
  const wishlistKey = "shopify_wishlist";

  const heartEmpty = `
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-heart" viewBox="0 0 16 16">
      <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15"/>
    </svg>`;

  const heartFilled = `
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-heart-fill" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"/>
    </svg>`;

  function formatMoney(cents, currency = '$') {
    const amount = (cents / 100).toFixed(2);
    return `${currency}${amount}`;
  }

  function getWishlist() {
    return JSON.parse(localStorage.getItem(wishlistKey) || "[]");
  }

  function saveWishlist(list) {
    localStorage.setItem(wishlistKey, JSON.stringify(list));
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function addToWishlist(handle) {
    const list = getWishlist();
    if (!list.includes(handle)) {
      list.push(handle);
      saveWishlist(list);
      updateWishlistCount();
    }
  }

  function removeFromWishlist(handle) {
    let list = getWishlist();
    list = list.filter(h => h !== handle);
    saveWishlist(list);
    updateWishlistCount();

    const pageItem = document.querySelector(`.wishlist-item[data-handle="${handle}"]`);
    if (pageItem) {
      pageItem.remove();
    }

    const remaining = getWishlist();
    if (document.querySelector("#wishlist-items") && remaining.length === 0) {
      document.querySelector("#wishlist-items").innerHTML = "<p>Your wishlist is empty.</p>";
    }
  }

  function updateWishlistCount() {
  const count = getWishlist().length;
  const badges = document.querySelectorAll(".wishlist-count"); // all matching elements

  badges.forEach((badge) => {
    if (count > 0) {
      badge.textContent = count;
      badge.style.display = "flex";
    } else {
      badge.style.display = "none";
    }
  });
}

  // ✅ Event delegation for dynamically loaded buttons
  document.body.addEventListener("click", function (e) {
    const btn = e.target.closest(".wishlist-btn");
    if (!btn) return;

    const handle = btn.dataset.productHandle;
    if (!handle) return;

    if (isInWishlist(handle)) {
      removeFromWishlist(handle);
      btn.innerHTML = heartEmpty;
    } else {
      addToWishlist(handle);
      btn.innerHTML = heartFilled;
    }
  });

  // ✅ Update icons based on current wishlist status
  function updateWishlistIcons() {
    document.querySelectorAll(".wishlist-btn").forEach(btn => {
      const handle = btn.dataset.productHandle;
      if (!handle) return;

      if (isInWishlist(handle)) {
        btn.innerHTML = heartFilled;
      } else {
        btn.innerHTML = heartEmpty;
      }
    });
  }

  // ✅ Render wishlist items on wishlist page
  if (document.querySelector("#wishlist-items")) {
    renderWishlist();
  }

  function renderWishlist() {
    const container = document.querySelector("#wishlist-items");
    container.innerHTML = "Loading...";

    const handles = getWishlist();
    if (handles.length === 0) {
      container.innerHTML = "<p>Your wishlist is empty.</p>";
      return;
    }

    Promise.all(
      handles.map(handle => fetch(`/products/${handle}.js`).then(r => r.json()))
    ).then(products => {
      container.innerHTML = "";
      products.forEach(product => {
        const div = document.createElement("div");
        div.className = "wishlist-item";
        div.dataset.handle = product.handle;
        div.innerHTML = `
          <a href="${product.url}" class="full-unstyled-link">
            <img src="${product.featured_image}" alt="${product.title}">
            <h3>${product.title}</h3>
            <p>${formatMoney(product.price)}</p>
          </a>
          <button class="remove-btn" data-handle="${product.handle}">Remove</button>
        `;
        container.appendChild(div);
      });

      container.querySelectorAll(".remove-btn").forEach(btn => {
        btn.addEventListener("click", () => {
          removeFromWishlist(btn.dataset.handle);
        });
      });
    });
  }

  // Initial setup
  updateWishlistCount();
  updateWishlistIcons();

  // Optional: If dynamic sections are injected later, call updateWishlistIcons() after they load
});
